import { QUERIED_FIELD_NAMES } from '../setup/settings';
import { LivePreviewConfig } from '../helpers/types';
import { createFieldNameConverter } from './fieldNames';
import { createEntryMerger } from './mergeWithBuildData';

export const createTransform = ({ bodyBlockTypeNames }: LivePreviewConfig) => {
  const fieldNameConverter = createFieldNameConverter(QUERIED_FIELD_NAMES);
  const { mergeEntry } = createEntryMerger(
    fieldNameConverter,
    bodyBlockTypeNames
  );

  return {
    convertFieldNames: fieldNameConverter.convertFieldNames,
    mergeEntry,
  };
};

export type Transform = ReturnType<typeof createTransform>;
